import { AfterViewInit, Directive } from "@angular/core";

import { Observable, of } from "rxjs";
import { TradableWalletService } from "../../services/wallet/tradable_wallet.service";
import { TradableWallet } from "@models/interfaces/tradable_wallet";
import { Tradable } from "@models/interfaces/tradable";
import { TradableService } from "../../services/currency/tradable.service";
import { TradableTransaction } from "@models/transaction";
import { CustomModal } from "../../../core/components/base-modals";
import { WalletCryptoDepositData } from "@models/interfaces/wallet-crypto-deposit-data";

@Directive()
export abstract class WalletEditComponent<T extends Tradable> extends CustomModal implements AfterViewInit {
	public data: WalletCryptoDepositData = null;
	public isRenameMode = false;

	protected abstract tradableWalletService: TradableWalletService<TradableWallet, TradableTransaction, T>;
	protected abstract tradableService: TradableService<T>;

	protected abstract callObservableAfterView(): void;
	protected abstract setWalletData(wallet: TradableWallet): void;

	protected getWalletObservable(): Observable<TradableWallet> {
		if (this.data.wallet.isNew()) {
			return of(this.data.wallet);
		}
		if (!this.isRenameMode) {
			return this.tradableWalletService.getAddressesForWallet(this.data.wallet);
		}
	}

	public ngAfterViewInit(): void {
		this.callObservableAfterView();
	}

	public getTradableSymbol(): string {
		return this.tradableService.getItemById(this.data.wallet.getCurrencyId()).getSymbol(false, true);
	}
}
